module.exports = __webpack_public_path__ + "img/catq_web.a9d92033.jpg";